export default {
  wrapper: (wrapperSx) => ({
    '& .MuiPaper-root': {
      borderRadius: '20px',
      backgroundColor: (theme) => theme.palette.grays.lightestGray,
      ...wrapperSx,

      '& .MuiAutocomplete-endAdornment': { display: 'flex' },
    },
  }),
  title: (titleSx) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0',
    paddingBottom: '24px',
    color: (theme) => theme.palette.grays.gray700,
    fontSize: '1.25rem',
    fontWeight: 700,
    ...titleSx,
  }),
  content: {
    padding: '0',
  },
  closeBtn: {
    '&:hover': {
      backgroundColor: 'transparent',
      color: (theme) => theme.palette.grays.gray500,
    },
    padding: '0px',
  },
  closeIcon: (closeIconSx) => ({
    width: '24px',
    color: (theme) => theme.palette.grays.gray500,
    '&:hover': {
      backgroundColor: 'transparent',
      color: (theme) => theme.palette.grays.gray500,
    },
    ...closeIconSx,
  }),
  actions: {
    padding: 0,
  },
};

export const modalFormSectionStyles = {
  wrapper: {
    padding: '24px',
    backgroundColor: '#fff',
    borderRadius: '8px',
    marginBottom: '16px',
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
  },
  title: {
    fontWeight: 700,
    fontSize: '1rem',
    color: (theme) => theme.palette.grays.gray600,
    marginBottom: '32px',
  },
};

export const modalFooterStyles = {
  wrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '8px',
    marginTop: '8px',
  },
};
